import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useAppStore } from '../store/useAppStore';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * CINTILLO DEL MODO DEMOSTRACIÓN
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * ── POR QUÉ ESTE COMPONENTE ES LA PIEZA MÁS IMPORTANTE DEL MODO DEMO ─────
 *
 * El modo demostración monta un viaje entero con un chofer inventado. Lo peor
 * que puede pasar en esta app es que alguien lo encienda, se le olvide, pida
 * un viaje creyendo que es de verdad, y se quede esperando en una acera a un
 * chofer que no existe. De noche, con una batería al 4%, eso no es un fallo de
 * software: es dejar tirada a una persona.
 *
 * Por eso el aviso NO es un diálogo al encenderlo —esos se leen una vez y se
 * olvidan— sino un cintillo que **no se quita de la pantalla** mientras el modo
 * esté encendido. Si está puesto, se ve. Siempre.
 *
 * ── Y POR QUÉ LLEVA SU PROPIO BOTÓN DE APAGAR ────────────────────────────
 *
 * Porque el sitio donde se enciende (Perfil) no es donde te das cuenta de que
 * está puesto (el mapa). Un aviso que te dice «estás en demostración» y te
 * obliga a buscar dónde se quitaba es medio aviso.
 *
 * ── LA OTRA MITAD DE LA SEGURIDAD ────────────────────────────────────────
 *
 * Esto es una de tres defensas, y ninguna basta sola:
 *   1. Este cintillo, siempre visible.
 *   2. El modo se APAGA SOLO al terminar el viaje de demostración (map.tsx),
 *      así que lo normal es que nadie se lo deje puesto.
 *   3. No se puede encender con un viaje de verdad en curso (profile.tsx).
 */
export default function CintilloDemostracion() {
  const enDemostracion = useAppStore((s) => s.qaMockRide);
  const apagar = useAppStore((s) => s.setQaMockRide);

  if (!enDemostracion) return null;

  return (
    <View style={estilos.caja} accessibilityRole="alert">
      <Ionicons name="flask" size={18} color="#7A3E00" />
      <View style={{ flex: 1, marginLeft: 9 }}>
        <Text style={estilos.titulo}>Modo demostración</Text>
        <Text style={estilos.texto}>
          El chofer y el viaje son de mentira, para que veas cómo funciona. No viene nadie a
          buscarte.
        </Text>
      </View>
      <TouchableOpacity
        onPress={() => apagar(false)}
        style={estilos.boton}
        accessibilityRole="button"
        accessibilityLabel="Salir del modo demostración"
      >
        <Text style={estilos.botonTexto}>Salir</Text>
      </TouchableOpacity>
    </View>
  );
}

const estilos = StyleSheet.create({
  // ⚠️ COLORES FIJOS, NO LOS DEL TEMA, Y ES A PROPÓSITO.
  // Este cintillo tiene que cantar en claro y en oscuro por igual: si se
  // mimetizara con la pantalla cumpliría la forma y no la función. El ámbar
  // sobre marrón oscuro da contraste de sobra en los dos temas.
  caja: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFE8B8',
    borderColor: '#E08700',
    borderWidth: 1.5,
    borderRadius: 12,
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  titulo: { fontSize: 13.5, fontWeight: '800', color: '#7A3E00' },
  texto: { fontSize: 11.5, lineHeight: 15.5, color: '#7A3E00', marginTop: 1 },
  boton: {
    backgroundColor: '#7A3E00',
    borderRadius: 9,
    paddingHorizontal: 12,
    // 36 px de alto: por debajo de eso el botón se falla con el pulgar.
    height: 36,
    justifyContent: 'center',
    marginLeft: 8,
  },
  botonTexto: { color: '#FFF', fontWeight: '800', fontSize: 12.5 },
});
